import admin from "@/modules/admin_context";
import auth from "@/modules/auth_context";
import basket from "@/modules/basket_context";
import customer from "@/modules/customer_context";
import order_status from "@/modules/order_status_context";
import search from "@/modules/search_context";
import table_to_basket from "@/modules/table_to_basket_context";
import user from "@/modules/user_context";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const isEnvProd = process.env.NODE_ENV == "production";

export default new Vuex.Store({
  modules: {
    admin,
    auth,
    basket,
    customer,
    order_status,
    search,
    table_to_basket,
    user
  },
  //enable strict mode during development
  strict: !isEnvProd
});
